import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Team billing", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" The ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Free Plan", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" is currently active ")
const _hoisted_5 = {
  key: 0,
  class: "error"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("As the team has more than 5 members you must upgrade to the ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Team Plan", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" to continue using Cadrelo")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Upgrade")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" The ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Team Plan", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" is currently active ")
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = {
  key: 1,
  class: "error"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" You can manage payment options, view invoices, cancel or renew your subscription in the ")
const _hoisted_17 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppPanel = _resolveComponent("AppPanel")!

  return (_openBlock(), _createBlock(_component_AppPanel, { class: "billing-panel" }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_ctx.activeTeam?.subscription?.plan === _ctx.Plan.FREE)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("p", null, [
              _hoisted_2,
              _createVNode(_component_router_link, { to: "/settings#plans" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _hoisted_4
            ]),
            (_ctx.activeMembers > 5)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_router_link, { to: "/settings#plans" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _hoisted_8
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_AppButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/settings', hash:'#plans' })))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.activeTeam?.subscription?.plan === _ctx.Plan.TEAM)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("p", null, [
              _hoisted_10,
              _createVNode(_component_router_link, { to: "/settings#plans" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _hoisted_12
            ]),
            (!_ctx.activeTeam.subscription.paid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, " The latest invoice for the team has not been paid. Please use the Customer Portal to update your payment details"))
              : _createCommentVNode("", true),
            (_ctx.activeTeam.subscription.cancelAt)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Your subscription will be cancelled on " + _toDisplayString(_ctx.activeTeam.subscription.cancelAt) + " unless renewed before then ", 1))
              : _createCommentVNode("", true),
            (_ctx.activeTeam.subscription.stripeCustomerId)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCustomerPortal()))
                  }, "Customer Portal")
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_17, " Thank you for being a foundational member of Cadrelo "))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}